export default __webpack_public_path__ + "3e4ff6c14d6d9c7a2a17adc55c7ec5b3.png";